






import { GCoinsHistory } from '@/components/gcoins';
import Vue from 'vue';

export default Vue.extend({
  name: 'GCoinsView',
  components: {
    GCoinsHistory,
  },
});
